import { render, staticRenderFns } from "./CardSubTotal.vue?vue&type=template&id=6cb85abb&"
import script from "./CardSubTotal.vue?vue&type=script&lang=js&"
export * from "./CardSubTotal.vue?vue&type=script&lang=js&"
import style0 from "./CardSubTotal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports